// extracted by mini-css-extract-plugin
module.exports = {"VideoSection":"VideoSection_VideoSection__tDsXd"};